import PageContainerFull from "../components/layout/PageContainerFull";
import PageSection from "../components/layout/PageSection";
import PageTitle from "../components/layout/PageTitle";
import Card from "../components/forms/Card";
import axios from "axios";
import {Apis} from "../util/data";
import {useContext, useEffect} from "react";
import logo from "../img/logo.png"
import useWindowDimensions from "../hooks/useWindowDimensions";
import FormGroup from "../components/forms/FormGroup";
import Input from "../components/forms/FormEl";
import Button from "../components/forms/Button";
import image from "../img/bannerpromsalud.png";
import {useForm} from "react-hook-form";
import {AuthContext} from "../context/AuthContext";
import {errorToast} from "../components/layout/ToastStyles";
import {useLocation, useNavigate} from 'react-router-dom';
import ForgotPassword from "./ForgotPassword";
import useModal from "../modals/useModal";
import GenericModal2 from "../modals/GenericModal2";
const Login = () => {

  const {
    register,
    handleSubmit,
    formState:{errors}
  } = useForm();

  const { height } = useWindowDimensions();

  const { setUsuario, user } = useContext(AuthContext);

  const navigate = useNavigate()
  const location = useLocation();

  useEffect(()=>{
    if(user?.token && location.pathname === '/login'){
      if(user.tipoUsuario === 1 || user.tipoUsuario === 2) navigate('/usuarios');
      else navigate("/horario");
    }
  },[user])

  const loginAdmin =async (params) =>{
    try {
      const {data} = await axios.post(Apis.PROD + "/api/v1/auth/authenticate/admin", params)
      if (data && data.token!== "validacion") {
        setUsuario(data)
      } else if(data) {
        await axios.get(Apis.PROD + '/api/v1/auth/send/activate/' + params.email)
        errorToast("Cuenta no validada, correo de validación reenviado, revise su correo")
      }
    }
    catch (error){
      errorToast("Error al ingresar a Admin")
      console.log(error)
    }
  }

  const {wrapper: wrapper1, someAction: openModal} = useModal({
    component: <ForgotPassword/>
  })

  const onSubmit = async (params) => {
    await loginAdmin(params)
  }

  return(
      <PageContainerFull style={{padding: 0}}>
        <div style={{display: "flex", flexDirection: "row", alignItems: 'center',height: '100%'}}>
          <div style={{padding: 10, height: height, display: "flex", flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center'}}>
            <img style={{height: 120,width: 120}} src={logo} alt={'logo'}/>
            <Card padding style={{width: '350px'}}>
              <PageSection>
                <PageTitle title={"Ingresar a Admin"}/>
              </PageSection>
              <PageSection>
                <FormGroup>
                  <label>Correo</label>
                  <Input type='email' {...register("email", {
                    required: "Ingrese su correo",
                  })}/>
                  {errors.email && <div style={{color:'red'}}>{errors.email.message}</div>}
                </FormGroup>
                <FormGroup>
                  <label>Contraseña</label>
                  <Input type='password' {...register("contrasena",{
                    required: "Por favor ingrese su contraseña",
                  })}/>
                  {errors.password && <div style={{color:'red'}}>{errors.password.message}</div>}
                </FormGroup>
              </PageSection>
              <PageSection style={{display: 'flex', flexDirection: 'column', gap: 15,justifyContent: 'center'}}>
                <Button onClick={handleSubmit(onSubmit)} variant={'primary'}>
                  Ingresar
                </Button>
                <Button onClick={openModal}>
                  Olvide mi contraseña
                </Button>
              </PageSection>
            </Card>
          </div>
          <img style={{overflow: 'hidden', height: height}} src={image} alt={'imagen'}/>
        </div>
        <GenericModal2 {...wrapper1}/>
      </PageContainerFull>
  )
}

export default Login
